import { useEffect } from 'react';
import CardContainer from 'src/components/CardContainer/CardContainer';
import { AddPaymentMethodPopup } from './AddPaymentMethodPopup/AddPaymentMethodPopup';
import { useGetPaymentMethodsQuery, useSetDefaultPaymentMethodMutation } from 'src/services';
import { LoaderWrapper } from 'src/components/LoaderWrapper/LoaderWrapper';
import { Skeleton } from 'src/components/ui/skeleton';
import { useLoaderWhile } from 'src/hooks/useLoaderWhile';

export const PaymentMethodCard = () => {
  const { data: paymentMethods, isFetching: paymentMethodsIsFetching } = useGetPaymentMethodsQuery(
    {},
    { refetchOnMountOrArgChange: true },
  );

  const [setDefaultPaymentMethod, { isLoading: isLoadingSetDefaultPaymentMethod }] =
    useSetDefaultPaymentMethodMutation();

  useLoaderWhile(paymentMethodsIsFetching, isLoadingSetDefaultPaymentMethod);

  useEffect(() => {
    if (paymentMethods?.data?.length === 1 && !paymentMethods?.data[0].default) {
      setDefaultPaymentMethod({ payment_method_id: paymentMethods?.data[0].id });
    }
  }, [paymentMethods]);

  const defaultPaymentMethod = paymentMethods?.data.find((paymentMethod) => paymentMethod.default);

  return (
    <CardContainer className={`half-width`}>
      <div className="card-header">
        <div className="title">
          <p className="text-ebony font-bold text-sm">Payment method</p>
        </div>
        <div className="edit-button-container">
          <AddPaymentMethodPopup
            paymentMethods={paymentMethods}
            disabled={paymentMethodsIsFetching}
          />
        </div>
      </div>
      <div className="card-body  h-full py-1">
        <div
          className={
            'input-container full-width border rounded-sm-5 h-full px-4 py-3.5 flex justify-between items-center'
          }
        >
          <LoaderWrapper
            loader={
              <div className="flex justify-between w-full items-end">
                <Skeleton className="h-4 w-full" />
              </div>
            }
            isLoading={paymentMethodsIsFetching}
          >
            {defaultPaymentMethod ? (
              <p className="font-medium text-base text-ebony opacity-70">
                <span className="capitalize">{defaultPaymentMethod.brand}</span>
                {' card'}
                <span> ****{defaultPaymentMethod.last4}</span>
              </p>
            ) : (
              <p className="font-medium text-base text-ebony opacity-70">
                No default payment method.
              </p>
            )}
          </LoaderWrapper>
        </div>
      </div>
    </CardContainer>
  );
};
